import { ignoreCancelledNavigation } from '@/lib/ignore-cancelled-navigation';
import type { IFormBuilderLinks } from '@commenda/ui';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { AffiliateFormHelper } from './affiliate-form-helper';

/** The workflow editor's way into the affiliate form builder: edit hrefs that carry the current
 * page as `?from=` so the builder's back button returns here, and navigation through this app's
 * router. A host that can show a form without leaving the page passes `onViewForm`, which adds the
 * panel's "View form" action. Creating a form belongs to the forms list. */
export const useAffiliateFormBuilderLinks = (
  firmId: string,
  onViewForm?: (formId: string, label: string) => void
): IFormBuilderLinks => {
  const router = useRouter();
  const currentHref = router.asPath;

  return useMemo(
    () => ({
      onViewForm,
      getEditHref: (formId: string) =>
        AffiliateFormHelper.getFormEditorHref(firmId, formId, currentHref),
      openHref: (href: string) => {
        router.push(href).catch(ignoreCancelledNavigation);
      },
    }),
    [router, firmId, currentHref, onViewForm]
  );
};
